<script setup lang="ts">
defineProps({
  href: {
    type: String,
    default: '',
  },
  title: {
    type: String,
    default: '',
  },
});
</script>

<template>
  <a
    :aria-label="title"
    class="social_link"
    :href="href"
    rel="noopener"
    target="_blank"
  >
    <slot />
  </a>
</template>

<style scoped lang="scss">
.social_link {
  @apply w-8 h-8 flex items-center justify-center bg-bg-primary rounded-full text-texts text-sm hover:opacity-100;

  &:hover {
    @apply bg-button-bg text-button-text;
  }
}
</style>
